.form {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-8x);
}

.field {
    flex: 1;
}

.horizontalFields {
    display: flex;
    gap: var(--bi-scale-8x);

    @media screen and (max-width: 480px) {
        gap: var(--bi-scale-5x);
    }
}
